module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_011.png
// module id = 2358
// module chunks = 5